// Regular expression from W3C HTML5.2 input specification:
// https://www.w3.org/TR/html/sec-forms.html#email-state-typeemail
export default {
  name: 'contact',
  props: {
    siteName: String
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'NH Roads',
          disabled: false,
          href: '/'
        },
        {
          text: 'Contact',
          disabled: false,
          href: '/contact'
        },
      ]
    }
  },
  async created() {
  },
  async mounted () {
  },
  methods: { 
  }}
